import React, { useEffect, useState, useRef, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://p2rxju-de.myshopify.com/cart/44671911067783:1?channel=buy_button';
const heroTestimonials = [{
  initials: 'MG',
  name: 'Mariela G.',
  role: 'Dueña Estética — CDMX',
  quote: 'Sumé Brow Extensions a mi salón en Polanco y estoy trabajando con +50 clientas nuevas estoy muy feliz!!'
}, {
  initials: 'LP',
  name: 'Laura P.',
  role: 'Esteticista — Guadalajara',
  quote: 'Mis clientas de pestañas y laminado amaron el nuevo servicio... vuelven cada 3 semanas por Brow Extensions también'
}, {
  initials: 'RM',
  name: 'Rocío M.',
  role: 'Lashista — Monterrey',
  quote: 'Llené mi agenda en una sola semana ofreciendo el servicio'
}];
const resultImages = ['https://cdn.magicpatterns.com/uploads/eA7mtCbRQrGw8Qn2PutU2F/WhatsApp_Image_2026-05-03_at_07.20.44.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/wL6aGDqFb48777ZA8eDtJx/WhatsApp_Image_2026-05-03_at_06.59.12.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const beforeImages = ['https://cdn.magicpatterns.com/uploads/befWjZNtk1Kzw6ruZphVyD/WhatsApp_Image_2026-05-02_at_22.08.03_(2).jpg', 'https://cdn.magicpatterns.com/uploads/g1egev8N4akbkZNtXocYzF/WhatsApp_Image_2026-05-02_at_22.08.03.jpg', 'https://cdn.magicpatterns.com/uploads/2K1CzXbcjYAezJTLa9sUSn/WhatsApp_Image_2026-05-02_at_22.15.42_(1).jpg'];
const lifeImages = ['https://cdn.magicpatterns.com/uploads/aL8Qcf1YcrbW3qCyv9ZFv8/WhatsApp_Image_2aa026-05-14_at_16.46.06_(3).jpg', 'https://cdn.magicpatterns.com/uploads/mvG1ANNPzfchqGvTXf38pD/WhatsApp_Image_2026-0a5-14_at_16.46.08_(2).jpg', 'https://cdn.magicpatterns.com/uploads/2DBJroGFbEQs5VRnDfsCpc/WhatsApp_Image_20d26-05-14_at_16.46.11.jpg', 'https://cdn.magicpatterns.com/uploads/gpL8XCTS7ums77QJZmEbh1/WhatsApp_Image_2026-j05-14_at_16.46.10_(1).jpg'];
const browTechniqueImages = ['https://cdn.magicpatterns.com/uploads/j5JTBTtCXaaFoDdZcPAaia/ChatGPT_Image_124_may_2026,_18_58_31.png', 'https://cdn.magicpatterns.com/uploads/cXWTGoBn2BYkM77XrHDfS8/WhatsApp_Image_2026-05-14_at_1a6.46.10_(2).jpg', 'https://cdn.magicpatterns.com/uploads/rY5WRbTAZQZQeX9CNFMbog/WhatsApp_Image_2026-05-14_at_16s.46.06_(2).jpg'];
export function HeroSection() {
  const [beforeSlide, setBeforeSlide] = useState(0);
  const [lifeSlide, setLifeSlide] = useState(0);
  const [browSlide, setBrowSlide] = useState(0);
  const [alumnasCount, setAlumnasCount] = useState(0);
  const statsRef = useRef<HTMLDivElement | null>(null);
  const hasAnimatedRef = useRef(false);
  useEffect(() => {
    if (!statsRef.current) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasAnimatedRef.current) {
          hasAnimatedRef.current = true;
          const target = 357;
          const duration = 2000;
          const startTime = performance.now();
          const step = (now: number) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setAlumnasCount(Math.floor(eased * target));
            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              setAlumnasCount(target);
            }
          };
          requestAnimationFrame(step);
        }
      });
    }, {
      threshold: 0.3
    });
    observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setBeforeSlide(prev => (prev + 1) % beforeImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setLifeSlide(prev => (prev + 1) % lifeImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setBrowSlide(prev => (prev + 1) % browTechniqueImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const painPoints = [{
    emoji: '❌',
    before: 'El rubro beauty está ',
    bold: 'cada vez más saturado',
    after: ''
  }, {
    emoji: '❌',
    before: 'Hay demasiadas lashistas ',
    bold: 'ofreciendo lo mismo',
    after: ''
  }, {
    emoji: '❌',
    before: 'Las clientas ya ',
    bold: 'no se sorprenden fácilmente',
    after: ''
  }, {
    emoji: '❌',
    before: 'Quieres diferenciarte pero ',
    bold: 'no sabes con qué',
    after: ''
  }, {
    emoji: '❌',
    before: 'Ves técnicas internacionales en redes… pero ',
    bold: 'nadie las enseña bien en tu país',
    after: ''
  }];
  return <section className="py-6 md:py-10 px-4 pt-[0px] pb-[0px] bg-[#2F0240] space-y-[0px]" data-id="element-86">
      <div className="max-w-6xl mx-auto" data-id="element-87">
        <div className="text-center mb-8" data-id="element-88">
          <div className="inline-flex items-center gap-2 text-white px-6 py-2.5 rounded-full font-bold text-sm uppercase tracking-wider shadow-[0_0_15px_rgba(34,197,94,0.5)] animate-glow-badge pt-[6px] pb-[6px] mt-[10px] mb-[10px] bg-[#9C16A3]" data-id="element-89">
            <span data-id="element-90"></span>
            <span data-id="element-91">50% OFF - CUPOS LIMITADOS</span>
          </div>

          <h2 className="md:text-5xl font-black mb-4 max-w-5xl mx-auto uppercase text-[#FFFFFF] text-[27px]" data-id="element-92">
            <span className="text-[#FACC15]" data-id="element-93">BROW EXTENSIONS:</span> La Nueva
            Tendencia Que Está por Explotar en México✨
          </h2>
          <h3 className="md:text-3xl font-bold mb-8 max-w-5xl mx-auto uppercase text-[#FC9DFF] text-[20px]" data-id="element-94">
            Y puedes ser una de las primeras en ofrecerlo...
          </h3>

          <div className="flex justify-center mb-8" data-id="element-95">
            <div className="w-full max-w-lg mt-[-20px] mb-[-20px]" data-id="element-96">
              <div className="relative" data-id="element-97">
                <div className="overflow-hidden rounded-lg shadow-2xl" data-id="element-98">
                  <div className="flex transition-transform duration-500 ease-in-out" style={{
                  transform: `translateX(-${browSlide * 100}%)`
                }} data-id="element-99">
                    {browTechniqueImages.map((img, index) => <img key={index} src={img} alt={`Brow Extensions - Técnica Hiperrealista ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 aspect-square object-cover" data-id="element-100" />)}
                  </div>
                </div>
                <button onClick={() => setBrowSlide(prev => (prev - 1 + browTechniqueImages.length) % browTechniqueImages.length)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" aria-label="Anterior" data-id="element-101">
                  <ChevronLeftIcon className="w-5 h-5" data-id="element-102" />
                </button>
                <button onClick={() => setBrowSlide(prev => (prev + 1) % browTechniqueImages.length)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" aria-label="Siguiente" data-id="element-103">
                  <ChevronRightIcon className="w-5 h-5" data-id="element-104" />
                </button>
                <div className="flex justify-center gap-2 mt-3" data-id="element-105">
                  {browTechniqueImages.map((_, index) => <button key={index} onClick={() => setBrowSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${browSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} aria-label={`Ir a slide ${index + 1}`} data-id="element-106" />)}
                </div>
              </div>
            </div>
          </div>

          <p className="md:text-2xl max-w-4xl mx-auto pt-[0px] pb-[0px] text-[17px] font-[500] mt-[0px] mb-[0px] text-[#FFFFFF]" data-id="element-107">
            ✨ Aprende la técnica hiperrealista que complementa pestañas,
            microblading y laminado.
          </p>

          <p className="md:text-2xl max-w-4xl mx-auto text-[17px] font-[500] mt-[0px] mb-[0px] text-[#FC9DFF] pt-[5px] pb-[5px]" data-id="element-108"></p>

          <div className="rounded-xl p-6 max-w-3xl mx-auto bg-[#9C16A3] animate-neon-violet pt-[15px] pb-[15px] mt-[15px] mb-[15px] pl-[0px] pr-[0px]" data-id="element-109">
            <p className="md:text-xl font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[15px]" data-id="element-110">
              ✨ Ofrece un servicio PREMIUM que ya es FUROR en Europa y LATAM🔥
            </p>
          </div>

          <div className="flex justify-center my-8" data-id="element-111">
            <button type="button" onClick={scrollToCompra} className="inline-block w-full md:w-auto px-8 py-4 text-lg md:text-xl font-black text-white bg-[#BE19BE] hover:bg-[#A015A0] rounded-lg text-center shadow-[0_0_15px_rgba(190,25,190,0.5),0_0_30px_rgba(190,25,190,0.3)] hover:shadow-[0_0_25px_rgba(190,25,190,0.7),0_0_50px_rgba(190,25,190,0.4)] transform hover:scale-105 transition-all duration-200 animate-cta-wiggle" data-id="element-112">
              QUIERO SER LA PRIMERA 👉
            </button>
          </div>

          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-113"></p>
        </div>

        <div className="text-center mt-[-10px] mb-[-10px]" data-id="element-114">
          <CTAButton text="QUIERO SER LA PRIMERA👉🏻" onClick={scrollToCompra} size="large" className="w-full md:w-auto text-2xl" data-id="element-115" />
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-116">
          <div className="flex justify-center mb-6" data-id="element-117">
            <CTAButton text="QUIERO SER LA PRIMERA 👉" onClick={scrollToCompra} size="large" className="w-full !bg-[#BE19BE] hover:!bg-[#A015A0] !text-white font-black text-xl shadow-[0_0_20px_rgba(190,25,190,0.6)] animate-pulse" data-id="element-118" />
          </div>
          <h3 className="md:text-3xl text-center uppercase text-[10px] font-[400] text-[#FFFFFF] pt-[15px] pb-[15px] mt-[-30px] mb-[-30px]" data-id="element-119">
            🛡️ Garantía 7 días 🔒 Pago seguro 💳 Mercado Pago ⭐+357 Alumnas
            ⚡Acceso en 5 minutos
          </h3>

          <div ref={statsRef} className="mt-6 rounded-3xl bg-[#1a0124] border border-[#FC9DFF]/30 shadow-2xl p-6 md:p-7" data-id="element-120">
            {/* Stats grid */}
            <div className="grid grid-cols-2 gap-x-4 gap-y-6 mb-7" data-id="element-121">
              <div className="text-left" data-id="element-122">
                <div className="text-white font-black text-[40px] leading-none tracking-tight tabular-nums" data-id="element-123">
                  +{alumnasCount}
                </div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug" data-id="element-124">
                  alumnas en Europa y Latinoamérica
                </div>
              </div>
              <div className="text-left" data-id="element-125">
                <div className="text-white font-black text-[40px] leading-none tracking-tight" data-id="element-126">
                  27
                </div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug" data-id="element-127">
                  clases completamente listas
                </div>
              </div>
              <div className="text-left" data-id="element-128">
                <div className="text-white font-black text-[40px] leading-none tracking-tight flex items-baseline gap-1" data-id="element-129">
                  4.9
                  <span className="text-[24px] text-white/70" data-id="element-130">/5</span>
                </div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug flex items-center gap-1" data-id="element-131">
                  calificación
                  <StarIcon className="w-4 h-4 fill-[#FC9DFF] text-[#FC9DFF]" data-id="element-132" />
                </div>
              </div>
              <div className="text-left" data-id="element-133">
                <div className="text-[40px] leading-none" data-id="element-134">🌎</div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug" data-id="element-135">
                  Todo el mundo hispanohablante
                </div>
              </div>
            </div>

            {/* Testimonial cards */}
            <div className="space-y-3" data-id="element-136">
              {heroTestimonials.map((t, i) => <div key={i} className="rounded-2xl border border-[#FC9DFF]/40 bg-[#2F0240]/60 p-4 flex gap-3 items-start" data-id="element-137">
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-[#9C16A3] flex items-center justify-center text-[#FC9DFF] font-black text-sm" data-id="element-138">
                    {t.initials}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-139">
                    <div className="flex items-center gap-0.5 mb-1" data-id="element-140">
                      {Array.from({
                    length: 5
                  }).map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-[#FC9DFF] text-[#FC9DFF]" data-id="element-141" />)}
                    </div>
                    <p className="text-white font-bold text-[15px] leading-snug mb-1" data-id="element-142">
                      "{t.quote}"
                    </p>
                    <p className="text-white/70 text-xs leading-snug" data-id="element-143">
                      — {t.name} | {t.role}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="rounded-2xl p-8 md:p-10 mb-10 max-w-3xl mx-auto bg-[#3E0400] pt-[20px] pb-[20px]" data-id="element-144">
          <h3 className="md:text-4xl font-black mb-8 text-center font-[Inter,_sans-serif] text-[#FFFFFF] text-[20px]" data-id="element-145">
            Si eres lashista, esteticista, especialista en laminado de cejas o
            microblading... esto te va a sonar familiar:
          </h3>
          <div className="space-y-4" data-id="element-146">
            {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 border border-amber-600/40 rounded-xl px-5 py-4 bg-gray-900/60" data-id="element-147">
                <span className="text-2xl flex-shrink-0 bg-gray-800 rounded-lg w-10 h-10 flex items-center justify-center" data-id="element-148">
                  {point.emoji}
                </span>
                <p className="text-base md:text-lg font-medium text-[#FFFFFF]" data-id="element-149">
                  {point.before}
                  <span className="font-bold text-[#FC9DFF]" data-id="element-150">{point.bold}</span>
                  {point.after}
                </p>
              </div>)}
          </div>
          <p className="text-center text-base md:text-lg font-semibold text-[#FC9DFF] mt-8 italic leading-relaxed" data-id="element-151"></p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-152">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl" data-id="element-153">
            <p className="md:text-xl font-bold mb-4 text-[18px] font-[Montserrat,_sans-serif] text-[#FACC15]" data-id="element-154">
              Y seguramente a muchas de tus clientas les sucede que...
            </p>
            <p className="md:text-lg text-white mb-4 text-[16px] font-[500] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-155">
              Ya se realizaron{' '}
              <span className="font-bold text-[#FC9DFF]" data-id="element-156">
                microblading o sombreado de cejas
              </span>
              .
            </p>
            <p className="md:text-lg text-white mb-3 text-[16px] font-[500] font-[Montserrat,_sans-serif]" data-id="element-157">
              Pero siguen sintiendo que:
            </p>
            <ul className="space-y-3 text-left mb-5" data-id="element-158">
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-159">
                ❌ las cejas se ven "dibujadas"
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-160">
                ❌ les falta textura real
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-161">
                ❌ quieren un acabado más natural
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-162">
                ❌ desean más hiperrealismo
              </li>
            </ul>
            <div className="my-5" data-id="element-163">
              <img src="https://cdn.magicpatterns.com/uploads/vubQeaQEpXXQL9tzzdahZt/ChatGPT_Image_15_may_2026,_01_18_18.png" alt="Comparación cejas con y sin Brow Extensions" loading="lazy" className="w-full rounded-xl shadow-lg" data-id="element-164" />
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center" data-id="element-165">
          <p className="md:text-xl mb-3 font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[22px]" data-id="element-166">
            La realidad es que ya no alcanza con hacer pestañas, microblading o
            laminado.
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-167">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl" data-id="element-168">
            <p className="md:text-xl font-bold text-white mb-4 text-[18px] font-[Montserrat,_sans-serif]" data-id="element-169">
              Las clientas buscan:
            </p>
            <ul className="space-y-3 text-left" data-id="element-170">
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-171">
                ✨ resultados mucho más realistas
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-172">
                ✨ técnicas innovadoras
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-173">
                ✨ servicios exclusivos
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-174">
                ✨ profesionales actualizadas
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-175">
                ✨ experiencias premium
              </li>
            </ul>
            <p className="md:text-lg text-[#FC9DFF] font-semibold mt-5 text-[16px] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-176"></p>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-10" data-id="element-177">
          <h3 className="text-2xl md:text-4xl font-black text-[#FACC15] leading-tight" data-id="element-178">
            👉🏻Hoy, los salones y showroom que más crecen son los que incorporan
            tendencias antes que el resto.
          </h3>
        </div>

        <div className="max-w-2xl mx-auto mb-4 mt-8" data-id="element-179">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl" data-id="element-180">
            <h4 className="md:text-2xl font-black mb-4 text-[20px] font-[Montserrat,_sans-serif] leading-snug text-[#FC9DFF]" data-id="element-181">
              Ahí es donde entra la Extensión de Cejas Pelo por Pelo.
            </h4>
            <p className="md:text-lg text-white mb-5 text-[16px] font-[500] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-182">
              Una técnica que ya es un{' '}
              <span className="font-bold text-[#FC9DFF]" data-id="element-183">
                éxito internacional
              </span>{' '}
              y que está a punto de explotar en toda Latinoamérica...
            </p>
            <p className="md:text-lg mb-3 text-[16px] font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF]" data-id="element-184">
              Porque permite:
            </p>
            <ul className="space-y-3 text-left mb-5" data-id="element-185">
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-186">
                ✔ reconstruir cejas despobladas
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-187">
                ✔ corregir asimetrías
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-188">
                ✔ crear efecto hiperrealista
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-189">
                ✔ rejuvenecer el rostro
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-190">
                ✔ complementar microblading
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-191">
                ✔ generar mantenimientos recurrentes
              </li>
            </ul>
            <p className="md:text-lg font-bold mt-5 mb-4 text-[16px] font-[Montserrat,_sans-serif] leading-relaxed text-[#FFFFFF]" data-id="element-192">
              Y lo mejor: todavía hay MUY poca competencia.
            </p>
          </div>
        </div>

        <div className="max-w-sm mx-auto mb-4" data-id="element-193">
          <div className="relative" data-id="element-194">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-195">
              <div className="flex transition-transform duration-700 ease-in-out" style={{
              transform: `translateX(-${lifeSlide * 100}%)`
            }} data-id="element-196">
                {lifeImages.map((img, index) => <img key={index} src={img} alt={`Nuestra vida ahora ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-square" data-id="element-197" />)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-3" data-id="element-198">
              {lifeImages.map((_, index) => <button key={index} onClick={() => setLifeSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${lifeSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-199" />)}
            </div>
          </div>
          <p className="text-center md:text-lg text-gray-200 mt-4 font-medium px-2 text-[17px] font-[Montserrat,_sans-serif]" data-id="element-200">
            ✨Ejemplos reales Brow Extensions✨
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-12" data-id="element-201">
          <h3 className="md:text-4xl font-[700] font-[Montserrat,_sans-serif] text-[#FC9DFF] mt-[0px] mb-[0px] text-[22px]" data-id="element-202">
            ¿Te imaginas poder ofrecerlo primero en tu zona...
          </h3>
          <p className="md:text-lg text-white text-[16px] font-[500] font-[Montserrat,_sans-serif] leading-relaxed mt-[30px] mb-[30px]" data-id="element-203">
            Las mismas clientas que vuelven todos los meses por{' '}
            <span className="font-bold text-[#FC9DFF]" data-id="element-204">
              pestañas o laminado
            </span>
            … pueden convertirse en tus próximas clientas Brow✨
          </p>
          <p className="md:text-2xl font-semibold text-white font-[Montserrat,_sans-serif] pt-[0px] pb-[0px] text-[30px]" data-id="element-205">
            Es por eso que creamos el Programa{' '}
            <span className="text-[#FC9DFF] font-black" data-id="element-206">BROW EXTENSIONS</span>
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-207">
          <img src="https://cdn.magicpatterns.com/uploads/68QWgGoKk9HTa8pZ5e2tNV/mockup_dominando_shopify_(1).png" alt="Programa Brow Extensions - Mockup" loading="lazy" className="w-full rounded-2xl shadow-2xl" data-id="element-208" />
          <p className="text-center md:text-lg font-medium px-2 font-[Montserrat,_sans-serif] text-[#FC9DFF] pt-[10px] pb-[10px] mt-[0px] mb-[0px] text-[17px]" data-id="element-209">
            🏆 El sistema más completo de extensión de cejas pelo por pelo y
            negocio para profesionales beauty de Latinoamérica ✨
          </p>
        </div>
      </div>
    </section>;
}